import { useGetApplication, useWithdrawApplication } from "api/application";
import ApplyButton from "components/ApplyNow/ApplyButton";
import Loader from "components/Loader";
import { t } from "i18next";
import { useParams } from "react-router-dom";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";

export const Applied = () => {
  const { dir } = useAppSelector(getSettings);
  const { id } = useParams();
  const { data, isLoading } = useGetApplication(id);
  const { mutate: withdrawApplication, isPending: withdrawingApplication } =
    useWithdrawApplication();

  const applicationDate = new Date(data?.createdAt).toLocaleString();

  return (
    <>
      <div
        className="flex flex-col max-w-max md:max-w-xl w-full mx-auto my-4 lg:my-20 px-5 lg:px-0 relative"
        dir={dir}
      >
        <Loader open={isLoading || withdrawingApplication} type="block" />
        <h2 className="font-bold text-3xl text-theme-blue text-center">
          {t("applyTabPostCongratsTitle")}
        </h2>
        <p className="text-theme-blue text-lg text-center mt-10">
          {t("applyTabPostCongratsText")}
          {applicationDate}
        </p>
        <div
          className="flex flex-col items-center gap-4 mx-auto py-8 bg-[#004E99] w-full mt-5 relative"
          dir={dir}
        >
          <div
            className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white triangle rotate-180 mt-2.5"
            style={{
              borderWidth: "0 21px 21px 21px",
              borderColor: "transparent transparent white transparent",
            }}
          />
          <ApplyButton
            text={t("applyNowButton")}
            className="max-w-xs disabled:opacity-50"
            disabled
          />
          <button
            className="text-theme-yellow text-lg underline"
            onClick={() => withdrawApplication(id)}
          >
            {t("applyTabPostCongratsWithdrawButton")}
          </button>
        </div>
      </div>
    </>
  );
};

export default Applied;
